// shrnutí objednávky
function summary() {
  // otevření okna
  $('.js-summary-open').on('click', function () {
    // otevření okna
    $('.summary').addClass('is-open');
    $('body').addClass('is-unscrollable');
  });

  // zavření summary okna
  $('.js-summary-close').on('click', function (event) {
    event.preventDefault();
    $(this).closest('.summary').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  });

  // zavření okna kliknutím na pozadí
  $('.summary').on('click', function (event) {
    event.preventDefault();
    $(this).removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  });

  // zamezení zavření po kliknutí na tělo summaryu
  $('.summary__body').on('click', function (event) {
    event.stopPropagation();
  });

  $('.show-coupon-link').on('click', function () {
    $('.coupon-input').removeClass('is-hidden');
  });

  $('.show-coupon-link-end').on('click', function () {
    $('.coupon-input-end').removeClass('is-hidden');
  });

  $('.changeStartDateEnd').on('click', function () {
    $('.changeStartDateEndDiv').removeClass('is-hidden');
  });

  $('.coupon-form').on('submit', function (e) {
    e.preventDefault();
  });

  let startDateInput = $('.start-date-input');
  let startDate = $('#possible-date-from').val();
  let defaultDate = $('#selected-date-from').val();
  if (defaultDate == 'undefined') {
    defaultDate = startDate;
  }
  let endDate = $('#possible-end-date-from').val();
  startDateInput.datetimepicker({
    minDate: moment(startDate, 'DD.MM.YYYY'),
    maxDate: moment(endDate, 'DD.MM.YYYY'),
    format: 'DD.MM.YYYY',
    locale: $('#input-locale').val(),
    useCurrent: false,
    defaultDate: moment(defaultDate, 'DD.MM.YYYY'),
  });

  $(document).ready(function () {
    let tmpDate = new Date();
    tmpDate.setDate(tmpDate.getDate() + 1);
    let sendDate = moment(tmpDate, 'DD.MM.YYYY');
    let form = startDateInput.closest('form');
    let url = form.attr('action');
    startDateInput.attr('value', sendDate);
    let formData = form.serializeArray();
    var selectedCoinsurance = $(
      "input[name='insurance_subject_order[coinsurance]']:checked"
    );
    var coinsuranceLength = selectedCoinsurance.data('length');
    formData.push({ name: 'insurance-length', value: coinsuranceLength });
    $.ajax({
      type: 'POST',
      url: url,
      data: formData, // serializes the form's elements.
      success: function (data) {
        /*var startDate = new Date(data.date);*/
        var startDate = new Date(data.dateFrom);
        var endDate = new Date(data.dateTo);
        endDate.setFullYear(endDate.getFullYear());
        $('.date-start-text').html(
          startDate.getDate() +
            '.' +
            (startDate.getMonth() + 1) +
            '.' +
            startDate.getFullYear() +
            ' do ' +
            endDate.getDate() +
            '.' +
            (endDate.getMonth() + 1) +
            '.' +
            endDate.getFullYear()
        );
        //TODO nastavit např. zelený box u inputu
      },
    });
  });

  startDateInput.on('dp.change', function (e) {
    let sendDate = e.date.format('DD.MM.YYYY');
    let form = $(this).closest('form');
    let url = form.attr('action');
    startDateInput.attr('value', sendDate);
    var selectedCoinsurance = $(
      "input[name='insurance_subject_order[coinsurance]']:checked"
    );
    var coinsuranceLength = selectedCoinsurance.data('length');
    let formData = form.serializeArray();
    formData.push({ name: 'insurance-length', value: coinsuranceLength });
    $.ajax({
      type: 'POST',
      url: url,
      data: formData,
      success: function (data) {
        /*var startDate = new Date(data.date);*/
        var startDate = new Date(data.dateFrom);
        var endDate = new Date(data.dateTo);
        endDate.setFullYear(endDate.getFullYear());
        $('.date-start-text').html(
          startDate.getDate() +
            '.' +
            (startDate.getMonth() + 1) +
            '.' +
            startDate.getFullYear() +
            ' do ' +
            endDate.getDate() +
            '.' +
            (endDate.getMonth() + 1) +
            '.' +
            endDate.getFullYear()
        );
        //TODO nastavit např. zelený box u inputu
      },
    });
  });
}
